/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automation_Template_Fallback_NameInputs */

const cs_automation_template_fallback_name = /** @type {(inputs: Automation_Template_Fallback_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Šablona automatizace`)
};

const en_automation_template_fallback_name = /** @type {(inputs: Automation_Template_Fallback_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automation template`)
};

/**
* | output |
* | --- |
* | "Automation template" |
*
* @param {Automation_Template_Fallback_NameInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const automation_template_fallback_name = /** @type {((inputs?: Automation_Template_Fallback_NameInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Template_Fallback_NameInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_template_fallback_name(inputs)
	return cs_automation_template_fallback_name(inputs)
});